import useragent from '@finance/useragent';
import { getInstance } from '@finance/domain';
import urlParams from '../util/url-params';
/** 当前代码跑的环境 */
export const ENV = getInstance().env;
/**
 * 运营活动外部h5中配置使用随手记版还是卡牛版的url参数key
 *
 * 如： xxx?run_app=kn 即为使用卡牛版本
 * @readonly
 */
export const URL_KEY_FOR_RUN_APP = 'run_app';
/**
 * 运营活动外部h5中配置使用app内部还是外部的参数，主要用来做埋点配置
 *
 * 如： xxx?run_side=app 即为使用卡牛版本
 * @readonly
 */
export const URL_KEY_FOR_RUN_SIDE = 'run_side';
/**
 * emun For 标准的平台枚举 只有 kn ssj
 * @enum
 * @readonly
 */
export var APP;
(function (APP) {
    APP["kn"] = "kn";
    APP["ssj"] = "ssj";
})(APP || (APP = {}));
/**
 * emun For url中 run_side 对应的枚举
 * @enum
 * @readonly
 */
export var SIDE;
(function (SIDE) {
    SIDE["app"] = "app";
    SIDE["h5"] = "h5";
})(SIDE || (SIDE = {}));
/**
* 当前代码运行的 "平台"环境
*
* 随手记/卡牛app内部：当前是哪个app返回哪个
*
* app外部：根据 URL_KEY_FOR_RUN_APP=run_app 来判断是kn还是ssj，如果url中未指定，默认为ssj
* @type "ssj" | "kn"
* @readonly
*/
export const RUN_APP = (() => {
    const runApp = urlParams(URL_KEY_FOR_RUN_APP);
    let app;
    if (runApp) {
        app = APP[runApp];
    }
    if (useragent.isKaniu) {
        app = APP.kn;
    }
    if (useragent.isSuishouji) {
        app = APP.ssj;
    }
    // 最后检查
    if (!APP[app]) {
        app = APP.ssj;
    }
    return app;
})();
/**
 * 当前代码运行的 "端"环境
 *
 * 随手记/卡牛app内部：返回 app
 *
 * app外部：根据 URL_KEY_FOR_RUN_SIDE=run_side 来判断是app还是h5，如果url中未指定，默认为h5
 * @type "app" | "h5"
 * @readonly
 */
export const RUN_SIDE = (() => {
    if (useragent.isKaniu || useragent.isSuishouji) {
        return SIDE.app;
    }
    const runSide = urlParams(URL_KEY_FOR_RUN_SIDE);
    let side;
    if (runSide) {
        side = SIDE[runSide];
    }
    // 最后检查
    if (!SIDE[side]) {
        side = SIDE.h5;
    }
    // 后续如果要区分微信和h5则再增加相应的配置
    return side;
})();
const _default = {
    ENV,
    URL_KEY_FOR_RUN_APP,
    URL_KEY_FOR_RUN_SIDE,
    APP,
    SIDE,
    RUN_APP,
    RUN_SIDE,
};
export default _default;
